import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { steps, school } from "../mock/mock";


export default function Steps() {
  return (
    <section className="relative py-28 overflow-hidden bg-[#0B2545]" data-testid="steps-section">
      <div className="absolute inset-0 opacity-[0.07]" style={{ backgroundImage: "radial-gradient(#fff 1px, transparent 1px)", backgroundSize: "26px 26px" }} />
      <div className="absolute -top-40 -left-40 w-[34rem] h-[34rem] rounded-full bg-[#1B6CA8]/40 blur-3xl" />
      <div className="absolute -bottom-40 -right-20 w-[30rem] h-[30rem] rounded-full bg-[#ffce3a]/15 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-5">
        <div className="mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-[#ffce3a]/15 border border-[#ffce3a]/40 text-[#ffce3a] font-bold tracking-[0.18em] text-xs uppercase">Så funkar det</span>
          <h2 className="font-display text-4xl md:text-5xl font-extrabold text-white mt-5 leading-[1.05]">
            Fyra steg till <span className="relative inline-block text-[#ffce3a]">körkortet<span className="absolute left-0 right-0 -bottom-1 h-1.5 bg-[#ffce3a]/40 rounded-full" /></span>
          </h2>
        </div>

        <ol className="relative grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="hidden lg:block absolute top-[3.25rem] left-[12%] right-[12%] h-px bg-gradient-to-r from-transparent via-[#ffce3a]/60 to-transparent" />
          {steps.map((s, i) => {
            const last = i === steps.length - 1;
            return (
              <li key={s.n} style={{ animationDelay: `${i * 120}ms` }} className={`price-card group relative rounded-3xl p-7 border transition-all duration-300 hover:-translate-y-2 ${last ? "bg-[#ffce3a] border-[#ffce3a] text-[#0B2545] shadow-2xl shadow-[#ffce3a]/20" : "bg-white/[0.06] border-white/10 backdrop-blur-sm text-white hover:bg-white/[0.1] hover:border-[#ffce3a]/50"}`}>
                <span className={`font-display text-6xl font-black leading-none ${last ? "text-[#0B2545]/15" : "text-white/10"} group-hover:text-[#ffce3a]/40 transition-colors`}>0{s.n}</span>
                <h3 className="font-display font-extrabold text-xl mt-5 leading-tight">{s.title}</h3>
                <p className={`text-[15px] mt-2.5 leading-relaxed ${last ? "text-[#0B2545]/80" : "text-slate-300"}`}>{s.text}</p>
                {!last && <ArrowRight size={18} className="hidden lg:block absolute top-[3.1rem] -right-[1.35rem] text-[#ffce3a]/70" />}
              </li>
            );
          })}
        </ol>

        <div className="mt-14 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a href={school.bookingUrl} target="_blank" rel="noopener noreferrer" data-testid="steps-book-btn" className="group inline-flex items-center gap-2 px-8 py-4 rounded-xl bg-[#ffce3a] text-[#0B2545] font-extrabold text-lg hover:bg-[#ffd85f] transition-colors shadow-xl shadow-[#ffce3a]/20">
            Ta första steget – boka online
            <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
          </a>
          <Link to="/om-oss" className="inline-flex items-center gap-2 px-6 py-4 rounded-xl border border-white/20 text-white font-semibold hover:bg-white/10 transition-colors">
            Läs om utbildningen
          </Link>
        </div>
      </div>
    </section>
  );
}
